export var tabs = {
    defaultProps: {
        className: ""
    },
    styles: {
        base: {
            display: "block",
            overflow: "overflow-hidden"
        }
    }
};
export default tabs;
